// extracted by mini-css-extract-plugin
export default {"swiper_box":"index_swiper_box_sjhN2","swiper":"index_swiper_HdCQZ","swiper_item":"index_swiper_item_ryzvO"};